/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-08-30 10:59:05
 * @LastEditors: linxi
 * @LastEditTime: 2021-09-10 10:29:13
 */
import { FilterOutlined } from "@ant-design/icons";
import { Checkbox, Col, Dropdown, Menu, Row } from "antd";
import React, { useEffect, useRef, useState } from "react";

export interface FilterColumnProps {
  filterColumn?: any
  filterSelectList?: any
  onColumnVisibilityChange?: (selectedColumns: string[]) => void
}

export const FilterColumn: React.FC<FilterColumnProps> = ({
  filterColumn,
  filterSelectList,
  onColumnVisibilityChange,
}) => {

  const dropdownRef = useRef<HTMLDivElement>(null)

  const [visible, setVisible] = useState<any>(false)

  const [selectedColumns, setSelectedColumns] = useState<string[]>([])

  const [filterColumnList, setFilterColumnList] = useState<any>([])

  // 筛选中默认勾选的值
  useEffect(() => {
    setSelectedColumns(filterSelectList)
  }, [visible,filterSelectList])

  useEffect(() => {
    setFilterColumnList(filterColumn)
  }, [visible,filterColumn])

  // 处理列选中状态变化
  const handleColumnChange = (columnKey: string, checked: boolean) => {
    if (checked) {
      const data = [...selectedColumns, columnKey]
      setSelectedColumns(data);
      onColumnVisibilityChange && onColumnVisibilityChange(data);
    } else {
      const data = selectedColumns.filter(key => key != columnKey)
      setSelectedColumns(data);
      onColumnVisibilityChange && onColumnVisibilityChange(data);
    }
  }

  // 列筛选菜单
  const columnMenu = (
    <Menu style={{ maxHeight: 600, overflowY: 'auto' }}>
      <Menu.ItemGroup title="筛选列">
        {filterColumnList?.filter((item: any) => item?.field != 'checkbox')?.map((column: any) => {
          return (
            <Menu.Item key={column?.field}>
              <Checkbox
                checked={selectedColumns?.includes(column.field)}
                disabled={column?.pinned && column?.filter ? false : column?.pinned || column?.filter == false  ? true : false}
                onChange={(e) => handleColumnChange(column.field, e.target.checked)}
              >
                {column?.headerName}
              </Checkbox>
            </Menu.Item>
          )
        })}
      </Menu.ItemGroup>
      <Menu.Divider />
    </Menu>
  )

  return (
    <>
      <div ref={dropdownRef} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '32px', width: '30px' }}>
        <Dropdown
          overlay={columnMenu}
          trigger={['click']}
          onVisibleChange={(newVisible) => {
            setVisible(newVisible);
          }}
          visible={visible}>
          <FilterOutlined
            style={{ fontSize: '16px' }}
            onClick={(e) => {
              e.stopPropagation();
              setVisible(!visible);
            }}
          />
        </Dropdown>
      </div>
    </>
  );
}
